import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import React from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import { useTranslation } from 'react-i18next';
import useInformationDrawerStore from '../store/zustand/informationDrawer';

const GlobalInformationDrawer = function GlobalDrawer() {
  const { isOpen, informationContentKey, closeInformationDrawer } =
    useInformationDrawerStore();
  const { t: translate } = useTranslation('translation', {
    keyPrefix: 'INFORMATION_DRAWER'
  });

  const tileBox = (prefix: any) => (
    <ListItem>
      <ListItemText
        primary={translate(`${prefix}.title`)}
        primaryTypographyProps={{
          fontWeight: 'bold'
        }}
        secondary={translate(`${prefix}.subtitle`)}
      />
    </ListItem>
  );

  return (
    <Drawer
      PaperProps={{ sx: { width: '30%' } }}
      anchor="right"
      onClose={closeInformationDrawer}
      open={isOpen}
      sx={(theme) => ({ zIndex: theme.zIndex.drawer + 1 })}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '20px',
          width: '100%'
        }}
      >
        <IconButton
          aria-label="menu-close"
          color="inherit"
          edge="start"
          onClick={closeInformationDrawer}
          sx={{ mr: 2 }}
        >
          <ClearIcon />
        </IconButton>
      </Box>
      <Box
        sx={{
          paddingX: '12px'
        }}
      >
        <List>
          {informationContentKey &&
            informationContentKey.map((key) => tileBox(key))}
        </List>
      </Box>
    </Drawer>
  );
};

GlobalInformationDrawer.defaultProps = {
  children: undefined,
  position: 'right',
  width: '70%'
};

export default GlobalInformationDrawer;
